/* TailorTail Co — Newsletter Popup */

(function() {
  'use strict';

  var overlay = document.querySelector('[data-newsletter-popup-overlay]');
  var modal = document.querySelector('[data-newsletter-popup]');
  if (!modal || !overlay) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var closeBtn = modal.querySelector('[data-newsletter-popup-close]');
  var previousFocus = null;

  var configEl = document.querySelector('[data-newsletter-popup-config]');
  var config = { delay: 5, days: 30, buttonText: 'Claim My 10% Off' };
  if (configEl) {
    try { config = JSON.parse(configEl.textContent); } catch(e) {}
  }

  var STORAGE_KEY = 'tt_popup_dismissed';
  var SUBMITTING_KEY = 'tt_popup_submitting';

  function isDismissed() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return false;
    if (config.days === 0) return true;
    var timestamp = parseInt(stored, 10);
    var now = Date.now();
    var elapsed = now - timestamp;
    var ttl = config.days * 24 * 60 * 60 * 1000;
    return elapsed < ttl;
  }

  function markDismissed() {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  function openPopup() {
    previousFocus = document.activeElement;
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var emailInput = modal.querySelector('[data-newsletter-popup-email]');
    if (emailInput) emailInput.focus();
  }

  function closePopup() {
    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    markDismissed();
    if (previousFocus) previousFocus.focus();
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closePopup();
    }
  });

  // Mark submitting on form submit (before page reloads)
  var form = modal.querySelector('[data-newsletter-popup-form]');
  if (form) {
    form.addEventListener('submit', function() {
      localStorage.setItem(SUBMITTING_KEY, '1');
    });
  }

  // Detect Liquid-rendered states after page reload
  var successState = modal.querySelector('[data-newsletter-popup-success]');
  var errorState = modal.querySelector('[data-newsletter-popup-error]');
  var wasSubmitting = localStorage.getItem(SUBMITTING_KEY);

  if (successState) {
    localStorage.removeItem(SUBMITTING_KEY);
    markDismissed();
    openPopup();
  } else if (errorState) {
    localStorage.removeItem(SUBMITTING_KEY);
    openPopup();
  } else if (wasSubmitting) {
    // Page reloaded mid-submit but no success/error rendered — clear flag, stay hidden
    localStorage.removeItem(SUBMITTING_KEY);
  } else if (!isDismissed()) {
    var delayMs = (config.delay || 5) * 1000;
    setTimeout(openPopup, delayMs);
  }

  // Copy discount code button
  var copyBtn = modal.querySelector('[data-newsletter-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      var codeEl = modal.querySelector('.popup__discount-value');
      if (codeEl && navigator.clipboard) {
        navigator.clipboard.writeText(codeEl.textContent.trim());
        copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        setTimeout(function() {
          copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>';
        }, 2000);
      }
    });
  }

  window.TailorTail = window.TailorTail || {};
  window.TailorTail.openNewsletterPopup = openPopup;
  window.TailorTail.closeNewsletterPopup = closePopup;
})();
